module.exports = __webpack_public_path__ + "img/fi-street-food-800x527.d50f177a.jpg";